export default __webpack_public_path__ + "assets/images/3d7754b4b4ea06671dcdd2910a777b50.jpg";